<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>项目列表</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search-box">
            <el-form :inline="true" :model="formFilter" class="demo-form-inline">
                <el-form-item label="创建时间">
                    <el-date-picker
                        v-model="formFilter.daterange"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onFilter">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-box">
            <div class="table" style="padding-top: 15px;">
                <el-table
                    :data="lists"
                    :border="true"
                    :stripe="true"
                >
                    <el-table-column
                        prop="no"
                        align="center"
                        label="项目编号">
                    </el-table-column>
                    <el-table-column
                        prop="create_time"
                        align="center"
                        label="创建时间">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        align="center"
                        label="项目名称">
                    </el-table-column>
                    <el-table-column
                        prop="complete_time"
                        align="center"
                        label="预计完成时间">
                    </el-table-column>
                    <el-table-column
                        label="状态"
                        align="center">
                        <template slot-scope="scope">
                            {{statusList[scope.row.status]}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="center"
                        width="150">
                        <template slot-scope="scope">
                            <el-button type="text" @click="goPage('/index/project/detail?id='+scope.row.id)" size="medium">详情</el-button>
                            <el-button type="text" v-if="scope.row.status === 7" @click="onDelete(scope.row.id)" size="medium">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination" v-if="total_page > 1">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-size="10"
                        :current-page="currentPage"
                        @current-change="onPageChange"
                        :page-count="total_page">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'Main',
    inject: ['goPage'],
    data () {
        return {
            formFilter: {
                daterange: [],
                start_time: '',
                end_time: ''
            },
            lists: [],
            total_page: 1,
            statusList: ['待支付', '待匹配', '服务待确认', '服务进行中', '成果待确认', '服务待结算', '已完成', '已关闭']
        }
    },
    computed: {
        ...mapState({
            currentPage: 'curPage',
            condition: 'formFilter'
        })
    },
    mounted () {
        if (this.condition) {
            this.formFilter = this.condition
        }
        this.getList()
    },
    methods: {
        getList (page = this.currentPage) {
            this.$http.get('/api/user/project/lists', {
                params: {
                    page,
                    size: 10,
                    start_time: this.formFilter.start_time,
                    end_time: this.formFilter.end_time
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.lists = res.data.listData
                        this.total_page = res.data.total_page
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                    // this.$message.warning(res.message)
                })
        },
        onFilter () {
            this.formFilter.start_time = this.getDateFromRange(this.formFilter.daterange)[0]
            this.formFilter.end_time = this.getDateFromRange(this.formFilter.daterange)[1]
            this.$store.commit('changeCondition', this.formFilter)
            this.getList(1)
        },
        onPageChange (e) {
            this.$store.commit('changePage', e)
            this.getList(e)
        },
        getDateFromRange (d) {
            let daterange = !d ? [] : d
            let date0 = !(daterange[0] === '' || !daterange[0]) ? `${daterange[0].getFullYear()}-${daterange[0].getMonth() + 1}-${daterange[0].getDate()}` : ''
            let date1 = !(daterange[1] === '' || !daterange[1]) ? `${daterange[1].getFullYear()}-${daterange[1].getMonth() + 1}-${daterange[1].getDate()}` : ''
            return [date0, date1]
        },
        onDelete (id) {
            this.$confirm('此操作将永久删除该项目, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.get('/api/user/project/del', {
                    params: {
                        id
                    }
                })
                    .then(res => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: '删除成功'
                            })
                            this.getList()
                        } else {
                            this.$message.warning(res.message)
                        }
                    })
                    .catch(err => {
                        console.error(err)
                        // this.$message.warning(res.message)
                    })
            }).catch((err) => {
                console.log(err)
            })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";
</style>
